module.exports = __webpack_public_path__ + "img/stand_on.47ea4e22.svg";